"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  AppInfo: () => AppInfo
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
function readAppInfo() {
  var _native_version, _native_build, _native_applicationId;
  if (!import_react_native_nitro_modules.NitroModules.hasHybridObject("OneAppInfo")) {
    return {
      version: null,
      build: null,
      applicationId: null
    };
  }
  var native = import_react_native_nitro_modules.NitroModules.createHybridObject("OneAppInfo");
  return {
    version: (_native_version = native.version) !== null && _native_version !== void 0 ? _native_version : null,
    build: (_native_build = native.build) !== null && _native_build !== void 0 ? _native_build : null,
    applicationId: (_native_applicationId = native.applicationId) !== null && _native_applicationId !== void 0 ? _native_applicationId : null
  };
}
var AppInfo = Object.freeze(readAppInfo());
//# sourceMappingURL=index.native.js.map
